const API = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot/me',
  CHECK_TOKEN: '/reset/me/',
  RESET_PASSWORD: '/reset/me/',
  CONTACT: '/contact',
  CHANGE_PASSWORD: '/change/password',
  PROFILE: '/users/me',
  PROFILE_CHANGE_PASSWORD: '/users/change_password',
  ADMIN_COMPANY: 'admin/vendors',
  ADMIN_COMPANY_GET: 'admin/vendors/',
  ADMIN_COMPANY_COPY: 'admin/vendors/',
  ADMIN_EMPLOYEE: 'admin/users',
  ADMIN_EMPLOYEE_GET: 'admin/users/',
  ADMIN_CONTACT: '/admin/contacts',
  ADMIN_CONTACT_GET: '/admin/contacts/',
  ADMIN_ROLE: '/admin/roles',
  ADMIN_ITEMS: 'admin/items',
  ADMIN_FOLDER: 'admin/folders',
  ADMIN_FOLDER_DETAIL: 'admin/folders/',
  ADMIN_FILE: 'admin/files',
  ADMIN_FILE_CHUNK: 'admin/files/chunk',
  ADMIN_FILE_CHECK_UPLOAD: 'admin/files/check_upload/',
  ADMIN_FILE_DETAIL: 'admin/files/',
  VENDOR: '/admin/vendors',
  ADMIN_VENDOR: '/admin/vendors/',
  ADMIN_DASHBOARD: '/admin/statistic_vendors',
  ADMIN_GET_TAG: '/admin/tags',
  ADMIN_GET_HISTORY_LOGS: '/admin/history_logs',
  ADMIN_AUTHOR: '/admin/search_users',
  MANAGER: 'manager/users',
  MANAGER_EMPLOYEE: 'manager/users/',
  ADD_EMPLOYEE: 'manager/users',
  PROFILE_VENDOR: 'manager/vendors/me',
  MANAGER_ITEMS: 'manager/items',
  MANAGER_FOLDER: 'manager/folders',
  MANAGER_FOLDER_DETAIL: 'manager/folders/',
  MANAGER_FILE: 'manager/files',
  MANAGER_FILE_CHUNK: 'manager/files/chunk',
  MANAGER_FILE_CHECK_UPLOAD: 'manager/files/check_upload/',
  MANAGE_VIDEOS: 'videos',
  MANAGER_FILE_DETAIL: 'manager/files/',
  MANAGER_VENDOR_SUMARY: '/manager/vendors/summary',
  MANAGER_RANKING_USER: '/manager/ranking_users',
  MANAGER_RANKING_FILE: '/manager/ranking_files',
  MANAGER_TAG: '/manager/tags',
  MANAGER_HISTORY: '/manager/history_logs',
  MANAGER_AUTHOR: '/manager/search_users',
  EMPLOYEE_PROFILE_VENDOR: 'employee/vendors/me',
  EMPLOYEE: '/vendor/employees',
  EMPLOYEE_DASHBOARD_SUMMARY: '/employee/vendors/summary',
  EMPLOYEE_RANKING_USER: '/employee/ranking_users',
  EMPLOYEE_RANKING_FILE: '/employee/ranking_files',
  EMPLOYEE_NEW_FILE: '/employee/new_files',
  EMPLOYEE_FILE: '/employee/files',
  EMPLOYEE_DETAIL_FILE: '/employee/files/',
  EMPLOYEE_FILE_LOG: '',
  EMPLOYEE_FOLDER: '/employee/items',
  EMPLOYEE_FOLDER_SEARCH: '/employee/folders',
  EMPLOYEE_FOLDER_DETAIL: '/employee/folders/',
  EMPLOYEE_NOTI: '/employee/notifications',
  EMPLOYEE_UPDATE_NOTI: '/employee/notifications/',
  EMPLOYEE_FAVORITE: '/employee/favorite_files',
  EMPLOYEE_HISTORY: '/employee/history_logs',
  EMPLOYEE_TAG: '/employee/tags',
  EMPLOYEE_AUTHOR: '/employee/search_users',
  ADMIN_USER_INQUIRY: 'admin/update_user_inquiry',
  MANAGER_ARCHIVE_EMPLOYEE: 'manager/archiveEmployee/',
  ARCHIVE_FILEFOLDER: 'manager/archiveFileFolder',
  UNARCHIVE_FILEFOLDER: 'manager/unArchiveFileFolder',
  ADMIN_PARENT_COMPANIES: '/companies',
  USER_COMPANY_IDS: '/getUserCompanyIds'
}

const STATUS = {
  SUCCESS: 200,
  CREATED: 201,
  DELETED: 204
}
const ROLE = {
  ADMIN: 1,
  MANAGER: 2,
  EMPLOYEE: 3
}
const MEDIA_TYPE = {
  FOLDER_ROLE_ID: 1,
  PDF_ROLE_ID: 2,
  IMAGE_ROLE_ID: 3,
  VIDEO_ROLE_ID: 4
}
const ACTION = {
  ACTION_TYPE_LOG_CREATE: 1,
  ACTION_TYPE_LOG_UPDATE: 2,
  ACTION_TYPE_LOG_READ: 3,
  ACTION_TYPE_LOG_LIKED: 4,
  ACTION_TYPE_LOG_LIKE_REMOVED: 5,
  ACTION_TYPE_LOG_COPY: 6,
  ACTION_TYPE_LOG_MOVE: 7
}
const STATUS_NOTIFICATION = {
  NOT_RECEIVE: 0,
  RECEIVE_CREATED: 1,
  RECEIVE_UPDATED: 2,
  RECEIVE_ALL: 3
}

export {
  API,
  STATUS,
  ROLE,
  MEDIA_TYPE,
  ACTION,
  STATUS_NOTIFICATION
}



// WEBPACK FOOTER //
// ./src/utils/constant.js